// src/projects/projectSubscriptions.js
import { useProjectStore } from "../stores/useProjectStore";
import { useAoiStore } from "../stores/useAoiStore";
import { hydrateProjectContext } from "./projectHydration";

let wired = false;

export function wireProjectSubscriptions() {
    if (wired) return;
    wired = true;

    useProjectStore.subscribe(
        s => s.activeProject?.id ?? null,
        async (next, prev) => {
            if (next === prev) return;

            // 1. Ensure backend truth is current
            await hydrateProjectContext();

            // 2. Reload AOIs under resolved project
            const aoiStore = useAoiStore.getState();
            aoiStore.clearSelection();
            await aoiStore.loadAois();
        }
    );
}